import React, { Component } from 'react';

import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';

import Summary from '../components/Summary';
import ContractsContainer from '../containers/ContractsContainer';
import { Col, Row } from 'react-bootstrap';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import SaveStepButton from './SaveStepButton';
import { WAButton } from '../components/Button.js';

class CheckOut extends Component {

    render() {
        let summary = (<Col xs={12} md={8} lg={5}><Summary /></Col>);

        if (['ftyc', 'fiduciaria', 'cuyoaval'].includes(process.env.PAGE)){
            summary = (
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                    <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <FormattedHTMLMessage id="app.step_checkout" description="Checkout info"/>
                    <div className="show-desktop">
                        <WAButton phone={this.context.intl.formatMessage({
                                    id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                text={this.context.intl.formatMessage({
                                    id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                value={this.context.intl.formatMessage({
                                    id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                        <SaveStepButton/>
                    </div>
                </div>
            );
        }

        return (
            <Section className="intro_form">
                <div className="pvc-form">
                    <Row>
                        {summary}
                        <Col xs={12} md={4} lg={7}>
                            <Row>
                                <Col xs={12} md={4} lg={1}>
                                </Col>
                                <Col xs={12} md={4} lg={11}>
                                    <ContractsContainer/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className="show-mobile">
                    <WAButton phone={this.context.intl.formatMessage({
                                id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                            text={this.context.intl.formatMessage({
                                id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                            value={this.context.intl.formatMessage({
                                id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                            gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                    <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    <SaveStepButton/>
                </div>
            </Section>
        );
    }
}


CheckOut.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

CheckOut = TopScrolleable(CheckOut);
CheckOut = withAuthControl(CheckOut);
export default CheckOut;



/** WEBPACK FOOTER **
 ** ./src/components/CheckOut.js
 **/